import "./Viewer.css";
import React, { Component } from "react";
import { TbMoodEmpty } from "react-icons/tb";
import { AiOutlineCloudDownload, AiOutlineDelete } from "react-icons/ai";
import { TbWorldUpload } from "react-icons/tb";

import Img2Img from "./Img2Img";
import Txt2Img from "./Txt2Img";

class Viewer extends Component {
    handlePublish = (id) => {
        const result = window.confirm("Hey there! Your awesome pic will be shared on ArtblastAI's public feed for everyone to enjoy! 😊")
        if (result) {
            this.props.publish(id)
        }
    }

    processDownload = async (imageURL) => {
        let pattern = /\.webp/g
        if (pattern.test(imageURL)) {

            // get urlData from webp image
            const blob = await (await fetch(imageURL, { cache: "no-cache" })).blob();
            let dataUrl = await new Promise(resolve => {
                let reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });

            const img = new Image();
            img.crossOrigin = 'Anonymous';

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);

                const pngDataUrl = canvas.toDataURL('image/png');
                this.downloadImage(pngDataUrl)
            };

            img.src = dataUrl;



        } else {
            this.downloadImage(imageURL)
        }
    };

    downloadImage = (imageURL) => {
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = 'artblastai-image.png';
        link.click();
    };



    render() {
        let mode;
        let imageURL;
        let initImageURL = null;
        const n = this.props.images.length;
        let txtPrompt = "";
        let galeryItem;
        if (n > 0) {
            galeryItem = this.props.galeryItem === null ? { ...this.props.images[0] } : { ...this.props.galeryItem }
            imageURL = galeryItem.imageHash
            if (galeryItem.initImage) {
                initImageURL = galeryItem.initImage
            }
            mode = initImageURL ? 2 : 1;
            txtPrompt = galeryItem.prompt;

        } else {
            mode = 3;
        }
        return (
            <div className="viewer-container">
                <div style={{ color: "white", textAlign: "center", fontSize: "10pt", margin: "5px" }}>Viewer</div>
                {mode === 1 && <>
                    <Txt2Img
                        loading={false}
                        latestImageURL={imageURL}
                        isViewer={true}
                    />
                </>
                }

                {mode === 2 && <>
                    <Img2Img
                        loading={false}
                        latestImageURL={imageURL}
                        initImageURL={initImageURL}
                        handleUploadInitImage={null}
                        isViewer={true}
                    />


                </>}

                {mode === 3 &&
                    <div className="image-container">
                        <div className="single-image">
                            <div className="empty">
                                <TbMoodEmpty size={200} />
                                <p>Your galery is empty!</p>
                            </div>
                        </div>
                    </div>
                }

                {mode !== 3 &&

                    <div className="button-share-cont">
                        <div className="button-share" disabled={this.props.publishing}
                            onClick={() => this.handlePublish(galeryItem._id)}>
                            <TbWorldUpload size={20} style={{ verticalAlign: "middle", marginRight: "5px" }} /> {" Publish"}
                        </div>
                        <div
                            className="button-share"
                            onClick={() => this.processDownload(imageURL)}
                        >
                            <AiOutlineCloudDownload size={20} style={{ verticalAlign: "middle", marginRight: "5px" }} />
                            {" Download"}
                        </div>
                        <div className="button-share"
                            onClick={this.props.handleDeleteImages.bind(this, galeryItem._id)}>
                            <AiOutlineDelete size={20} style={{ verticalAlign: "middle", marginRight: "5px" }} />
                            {" Delete"}
                        </div>

                    </div>

                }

                <p className="viewer-prompt">
                    {`Prompt: "${txtPrompt}"`}
                </p>

            </div>

        );
    }
}

export default Viewer;